/**
 * 将表单值（单选/多选/空值）规范化为 number[]
 * 用于搜索面板的大区/省/市/品牌/门店 ID 等，供 useLoadingPage / 下拉过滤使用
 */
export const normalizeToNumberArray = (value: any): number[] => {
  let arr: any[] = [];

  if (Array.isArray(value)) {
    arr = value;
  } else if (value !== undefined && value !== null && value !== "") {
    arr = [value];
  }

  return arr
    .map((v: any) => (typeof v === "number" ? v : Number(v)))
    .filter((v: number) => !Number.isNaN(v));
};

